(function() {
  'use strict';

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;

    event.preventDefault();

    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    const originalText = submitButton?.textContent || submitButton?.value;
    const formData = new FormData(form);

    if (submitButton) {
      submitButton.disabled = true;
      if (submitButton.textContent) {
        submitButton.textContent = 'Adding...';
      } else if (submitButton.value) {
        submitButton.value = 'Adding...';
      }
    }

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!addResponse.ok) {
        const errorText = await addResponse.text();
        let errorData;
        try {
          errorData = JSON.parse(errorText);
        } catch {
          errorData = { description: errorText || `Failed to add to cart: ${addResponse.status}` };
        }
        throw new Error(errorData.description || errorData.message || `Failed to add to cart: ${addResponse.status}`);
      }
      
      const responseData = await addResponse.json().catch(() => null);
      if (responseData && responseData.description) {
        throw new Error(responseData.description);
      }

      const cart = await fetch('/cart.js').then(r => r.json());

      const cartUpdateEvent = new CustomEvent('cart:updated', {
        bubbles: true,
        cancelable: false,
        detail: {
          cart: cart,
          item_count: cart.item_count || 0,
          items: cart.items || [],
          wasJustAdded: true
        }
      });
      document.dispatchEvent(cartUpdateEvent);
      
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          cart: cart,
          item_count: cart.item_count || 0,
          data: { itemCount: cart.item_count || 0 }
        }
      }));
      document.dispatchEvent(new CustomEvent('shopify:cart:update', {
        bubbles: true,
        detail: {
          cart: cart,
          item_count: cart.item_count || 0
        }
      }));

      if (window.dataLayer) {
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity') || '1', 10);
        
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: cart.currency || 'USD',
            value: cart.total_price / 100,
            items: [{
              item_id: variantId,
              item_name: cart.items?.find(item => item.variant_id == variantId)?.product_title || '',
              quantity: quantity,
              price: cart.items?.find(item => item.variant_id == variantId)?.price / 100 || 0
            }]
          }
        });
      }

      if (window.fbq) {
        const variantId = formData.get('id');
        const item = cart.items?.find(item => item.variant_id == variantId);
        if (item) {
          window.fbq('track', 'AddToCart', {
            content_name: item.product_title,
            content_ids: [variantId],
            content_type: 'product',
            value: item.price / 100,
            currency: cart.currency || 'AED'
          });
        }
      }

      const variantId = formData.get('id');
      const item = cart.items?.find(item => item.variant_id == variantId);
      if (item && window.showProductAddNotification) {
        window.showProductAddNotification(item);
      }

    } catch (error) {
      const errorMessage = error.message || 'Failed to add item to cart';
      alert(errorMessage);
      
      document.dispatchEvent(new CustomEvent('cart:error', {
        bubbles: true,
        detail: { error: error }
      }));
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        if (submitButton.textContent) {
          submitButton.textContent = originalText;
        } else if (submitButton.value) {
          submitButton.value = originalText;
        }
      }
    }
  });

  async function init() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: {
          cart: cart,
          item_count: cart.item_count || 0,
          items: cart.items || [],
          isInitialLoad: true
        }
      }));
    } catch (error) {
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();